<template>
  <div class="sidebarHelpItem">
    <div v-if="icon" data-test="icon">
      <CSSVGIcon :iconName="icon" class="sidebarHelpItem__icon" />
    </div>

    <p
      v-if="title"
      class="sidebarHelpItem__title"
      data-test="title"
      v-text="title"
    ></p>

    <p v-if="description" data-test="description" v-html="description"></p>
  </div>
</template>

<script>
import CSSVGIcon from '@/components/atoms/icons/CSSVGIcon.vue'

export default {
  name: 'SidebarHelpItem',

  components: {
    CSSVGIcon,
  },

  props: {
    icon: {
      type: String,
    },

    title: {
      type: String,
    },

    description: {
      type: String,
    },
  },
}
</script>
